import { render, staticRenderFns } from "./BlogDetailsLeftSidebar.vue?vue&type=template&id=2b6bee98&"
import script from "./BlogDetailsLeftSidebar.vue?vue&type=script&lang=js&"
export * from "./BlogDetailsLeftSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports